import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/stylesheet/Stylesheet.css";
import "./assets/stylesheet/newPage.css";
import "antd/dist/reset.css";
import { Router } from "./routes/Index";

function App() {

  return (
    <Router />
  );
}

export default App;
